<template>
    <div class="page-title-area bg-23">
        <div class="container">
            <div class="page-title-content">
                <h2>Services Details</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Services Details</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>